import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeReservationTypeProps } from '../types/interfaces'

import { TutorSlotType } from '@brighterly/lib-core-types/tutor/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeReservationTypeOptions {
  props: BadgeReservationTypeProps
}

interface BadgeReservationTypeReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<TutorSlotType, AppBadgeColor>> = {
  [TutorSlotType.DemoPriority]: 'red',
  [TutorSlotType.DemoCatchUp]: 'blue',
  [TutorSlotType.Paid]: 'emerald',
}

export const useBadgeReservationType = ({ props }: BadgeReservationTypeOptions): BadgeReservationTypeReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<TutorSlotType>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.tutor_slot.type,
  })
}
